/* global gtag */

/*

  STATE

 */

const state = {
  gaId: process.env.VUE_APP_GOOGLE_ANALYTICS_ID,
};


/*

  GETTERS

 */

const getters = {
};


/*

  ACTIONS

 */


const actions = {

  // init({ getters }) {
  //   const { appName } = getters;
  //   gtag('config', 'UA-134509524-2', {
  //     app_name: appName,
  //   });
  // },

  setUserId({ state }, uid) {
    gtag('config', state.gaId, {
      user_id: uid,
      send_page_view: false,
      custom_map: {
        dimension1: 'Display_Mode',
      },
    });
  },

  sendView({ state, rootState }, { name, param, path }) {
    // console.log('GA sendView', name, param, path);
    const { uid } = rootState.user;
    if (!name) {
      return;
    }
    const title = param ? `${name}: ${param}` : name;
    gtag('config', state.gaId, {
      page_title: title,
      page_path: path,
      user_id: uid,
      custom_map: {
        dimension1: 'Display_Mode',
      },
    });
  },

  setDisplayMode(context, isStandalone) {
    const mode = (isStandalone) ? 'Standalone' : 'Browser';
    gtag('event', 'Display_Mode', { Display_Mode: mode });
  },

  zippyClick(context, name) {
    gtag('event', `Zippy_${name}`, {
      event_category: 'Zippy',
      event_label: `Zippy_${name}`,
      value: 1,
    });
  },

  saveFavorite({ rootGetters }, cardId) {
    const category = rootGetters['ui/currentCategory'];
    gtag('event', 'Save_Favorite', {
      event_category: category,
      event_label: cardId,
      value: 1,
    });
  },

  removeFavorite({ rootGetters }, cardId) {
    const category = rootGetters['ui/currentCategory'];
    gtag('event', 'Remove_Favorite', {
      event_category: category,
      event_label: cardId,
      value: 0,
    });
  },

  viewDailyCard(context, { timeOfDay, cardId }) {
    const category = `${timeOfDay[0].toUpperCase()}${timeOfDay.slice(1)}`;
    gtag('event', 'Daily_Card_Click', {
      event_category: category,
      event_label: cardId,
      value: 1,
    });
  },

  categoryCardClick({ rootGetters }, { setName, id }) {
    const category = rootGetters['ui/currentCategory'];
    let event = setName;
    if (setName === 'allCategoryCards') {
      event = 'All_Cards_Category_Click';
    } else if (setName === 'favoriteCategoryCards') {
      event = 'Favorites_Category_Click';
    }
    gtag('event', event, {
      event_category: category,
      event_label: id,
      value: 1,
    });
  },

  randomCardClick({ rootGetters }, cardId) {
    const category = rootGetters['ui/currentCategory'];
    gtag('event', 'Random_Card_Category_Click', {
      event_category: category,
      event_label: cardId,
      value: 1,
    });
  },

  createStack(context, stackId) {
    gtag('event', 'Create_Stack', {
      event_category: 'Stacks',
      event_label: stackId,
      value: 1,
    });
  },

  editStack(context, stackId) {
    gtag('event', 'Edit_Stack', {
      event_category: 'Stacks',
      event_label: stackId,
      value: 1,
    });
  },

  deleteStack(context, stackId) {
    gtag('event', 'Delete_Stack', {
      event_category: 'Stacks',
      event_label: stackId,
      value: 1,
    });
  },

  saveFavoriteStack(context, stackId) {
    gtag('event', 'Save_Favorite_Stack', {
      event_category: 'Stacks',
      event_label: stackId,
      value: 1,
    });
  },

  removeFavoriteStack(context, stackId) {
    gtag('event', 'Remove_Favorite_Stack', {
      event_category: 'Stacks',
      event_label: stackId,
      value: 0,
    });
  },


  shareApp() {
    gtag('event', 'Share_App', {
      event_category: 'Share',
      event_label: 'Share_App',
      value: 1,
    });
  },

  getAppClick(context, location) {
    gtag('event', 'Get_App_Click', {
      event_category: 'Get_App',
      event_label: `Get_App_${location}`,
      value: 1,
    });
  },

  copyLinkClick() {
    gtag('event', 'Copy_Link_Click', {
      event_category: 'Get_App',
      event_label: 'Copy_Link_Click',
      value: 1,
    });
  },

  emailLinkToSelfClick() {
    gtag('event', 'Email_Link_To_Self_Click', {
      event_category: 'Get_App',
      event_label: 'Email_Link_To_Self_Click',
      value: 1,
    });
  },

  appUrlClick(context, location) {
    gtag('event', 'App_URL_Click', {
      event_category: 'Get_App',
      event_label: `App_URL_Click_${location}`,
      value: 1,
    });
  },

  appScreenshotView(context, image) {
    gtag('event', 'App_Screenshot_View', {
      event_category: 'Get_App',
      event_label: `App_Screenshot_${image}`,
      value: 1,
    });
  },

  acceptAddToHomeScreen() {
    gtag('event', 'Accept_Add_To_HS', {
      event_category: 'Get_App',
      event_label: 'Accept_Add_To_HS',
      value: 1,
    });
  },

  declineAddToHomeScreen() {
    gtag('event', 'Decline_Add_To_HS', {
      event_category: 'Get_App',
      event_label: 'Decline_Add_To_HS',
      value: 0,
    });
  },


};

/*

  MUTATIONS

 */

const mutations = {
  // exampleMutation(state, data) {
  //   state.property = data;
  // },
};


export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
